export default ({ eventName, detail }) => {
  document.body.dispatchEvent(
    new window.CustomEvent(eventName, {
      detail
    })
  )
}
